import * as React from 'react';

import { DateChip, DateWrapper } from '../components';

interface DatepickerYearsProps {
  className?: string;
  currentYear: number;
  maxYear: number;
  minYear: number;
  isDark?: boolean;
  onChange: (year: number) => void;
}

export const DatepickerYears: React.FC<DatepickerYearsProps> = (props) => {
  const getYears = () => {
    const years: number[] = [];
    for (let i = props.maxYear; i >= props.minYear; i--) {
      years.push(i);
    }
    return years;
  };

  return (
    <DateWrapper className={props.className}>
      {getYears()
        .reverse()
        .map((year) => (
          <DateChip
            className={`${props.isDark ? 'dark' : ''} ${
              year === props.currentYear ? 'active' : ''
            }`}
            key={year}
            weight="700"
            onClick={(ev) => {
              props.onChange(year);
              ev.stopPropagation();
            }}
          >
            {year}
          </DateChip>
        ))}
    </DateWrapper>
  );
};

export default DatepickerYears;
